import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useMediaQuery } from '@common/hooks';
import { GTMTracking } from '@common/ui/general';
import {
  updateRequestParams,
} from '@alumni_v2/stores/reviews/actions';
import {
  requestParamsSelector,
} from '@alumni_v2/selectors/reviews';

import askQuestionIcon from '@alumni_v2/images/webp/AskQuestions.webp';
import chatIcon from '@alumni_v2/images/svg/chatIcon.svg';
import ellipse from '@alumni_v2/images/svg/Ellipse.svg';
import glowingPowerIcon from '@alumni_v2/images/webp/purplePowerIcon.webp';
import mwebAskQuestionIcon from
  '@alumni_v2/images/webp/mobileAskQuestions.webp';
import smallPowerIcon from '@alumni_v2/images/svg/smallPowerIcon.svg';
import starIcon from '@alumni_v2/images/svg/whiteStarIcon.svg';
import userIcon from '@alumni_v2/images/svg/whiteUserIcon.svg';

import styles from './QuestionBanner.module.scss';

const QuestionBanner = ({ onBannerClick }) => {
  const dispatch = useDispatch();
  const requestParams = useSelector(requestParamsSelector) || {};

  const { tablet } = useMediaQuery();

  const hasQnAFilter = requestParams.quickFilters.includes('q&a_with_alumni');

  const onApply = useCallback(() => {
    onBannerClick();
    dispatch(
      updateRequestParams(
        ['q&a_with_alumni'], {}, null,
      ),
    );
  }, [dispatch, onBannerClick]);

  return (
    <GTMTracking
      component="div"
      gtmEventType="cta"
      gtmEventAction="click"
      gtmEventResult="apply_qna_filter"
      gtmEventCategory="alumni_directory"
      gtmEventData={{
        click_type: 'apply_qna_banner_filter',
        click_section: 'qna_banner',
      }}
      onClick={onApply}
      className={styles.questionBannerContainer}
    >
      <img className={styles.ellipse} src={ellipse} alt="ellipse" />
      {tablet ? (
        <img
          className={styles.askQuestions}
          src={mwebAskQuestionIcon}
          alt="askQuestions"
        />
      ) : (
        <img
          className={styles.askQuestions}
          src={askQuestionIcon}
          alt="askQuestions"
        />
      )}

      <div className={styles.mainContainer}>
        <div className={styles.mainBox}>
          <div className={styles.powerIcon}>
            <img src={glowingPowerIcon} alt="Glowing Power Icon" />
          </div>
          <div className={styles.askQuestionText}>
            <div className={styles.headingText}>Connect with Alumni</div>
            <div className={styles.subHeadingText}>
              <div>To the alumni with this tag</div>
              <img src={smallPowerIcon} alt="smallPowerIcon" />
            </div>
          </div>
        </div>

        <div className={styles.finalComponent}>
          <div className={styles.textContainer}>
            <div className={styles.introText}>
              Get on a 1-1 call with Scaler Alumni.
              This will help you with career advice, industry
              insights, Scaler experience and more.
            </div>
            <div className={styles.iconBoxContainer}>
              <div className={styles.iconBox}>
                <img src={starIcon} alt="starIcon" />
                <div>Know their Journey.</div>
              </div>
              <div className={styles.iconBox}>
                <img src={userIcon} alt="userIcon" />
                <div>Build your network.</div>
              </div>
            </div>
          </div>
          {!hasQnAFilter && (
            <div className={styles.applyButton}>
              <img src={chatIcon} alt="chatIcon" />
              <div>Apply Filter</div>
            </div>
          )}
        </div>
      </div>
    </GTMTracking>
  );
};

export default QuestionBanner;
